import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

interface PartnerMyMattersParams {
  limit?: number;
  enabled?: boolean;
}

export function usePartnerMyMatters({ limit = 10, enabled = true }: PartnerMyMattersParams = {}) {
  return useQuery({
    queryKey: dashboardQueryKeys.partnerMyMatters(limit),
    queryFn: () => dashboardApi.getPartnerMyMatters({ limit }),
    enabled,
    // Keep the current rows on screen while a bigger page loads (no skeleton flash).
    placeholderData: keepPreviousData,
  });
}
